<template>

    <div class="toast" :class="type ? `type--${type}` : ''">
        <p>
            {{content}}
        </p>
    </div>

</template>

<script>
export default {
    data(){
        return{
            content: '',
            duration: 3000,
            type: ''
        }
    },
    mounted(){
        setTimeout(()=>{
            this.$destroy(true);//duration后销毁
            this.$el.parentNode.removeChild(this.$el)
        },this.duration);
    }
}
</script>

<style lang='less' scoped>

.toast{
    display: flex;
    align-items:center;
    justify-content: center;
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    color: #fff;
    z-index: 9999;
    background:transparent;
    p{
        padding:0.24rem 0.44rem;
        font-size: 0.36rem;
        border-radius: 0.08rem;
        background:rgba(17,17,17,0.7);
    }
    &--error p{background:rgba(255,0,0,0.5)}
    &--success p{background:rgba(0,255,0,0.5)}
}

</style>




// WEBPACK FOOTER //
// src/components/toast/toast.vue